import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/share';
@Injectable({
  providedIn: 'root'
})

export class OrganisationSettingsService {
  private organisationId = null;
  private organisationSettings = null;
  private organisationSettingsObservable = null;
  private orgSettingsApiUrl = null;
  private orgPresalesSettingsApiUrl = null;

  constructor(private http: HttpClient) {
    this.orgSettingsApiUrl = environment.orgSettingsApiUrl;
    this.orgPresalesSettingsApiUrl = environment.orgPresalesSettingsApiUrl;
  }

  setOrganisationId(organisationId) {
    if (organisationId !== this.organisationId) {
      this.organisationSettings = null;
      this.organisationSettingsObservable = null;
      this.organisationId = organisationId;
    }
  }

  getSettings() {
    if (this.organisationSettings) {
      return of(this.organisationSettings);
    } else if (this.organisationSettingsObservable) {
      return this.organisationSettingsObservable;
    } else {
      this.organisationSettingsObservable = this._getSettings()
        .map(response => {
          this.organisationSettingsObservable = null;
          this.organisationSettings = (<any>response).Result;
          return this.organisationSettings;
        })
        .share();
      return this.organisationSettingsObservable;
    }
  }

  private _getSettings() {
    // console.log('settings call');
    // return of({ Result: { General: { UnitType: 'metric' }, PreSales: { EbiSystemNumber: '', CdtStatus: '' } } });
    return this.http.get(this.orgSettingsApiUrl + '/' + this.organisationId + '?pulseDeploymentList=false');
  }
  setSettings(organisationSettings) {
    return this.http.post(this.orgPresalesSettingsApiUrl + '/' + this.organisationId, organisationSettings);
  }
}
